import * as React from 'react';
import { Props, propTypes } from './props';
import { User } from 'types/user';
import { getI18n } from 'react-i18next';
import { translations } from 'types/translations';
import { Responsive } from 'semantic-ui-react';

import './styles.css';

export default class FullnameCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    const i18n = getI18n();
    const user = this.props.data as User;

    return (
      <>
        <Responsive {...Responsive.onlyMobile}>
          <div className="fullname-cell-details fullname-cell" data-id={user.id} data-username={user.username}>
            <span><span className="title">{i18n.t(translations.FirstName)}:</span>&nbsp;{user.firstName}</span>
            <span><span className="title">{i18n.t(translations.LastName)}:</span>&nbsp;{user.lastName}</span>
            <span><span className="title">{i18n.t(translations.Role)}:</span>&nbsp;{user.roleLabel}</span>
          </div>
        </Responsive>
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <div className="fullname-cell-details fullname-cell" data-id={user.id} data-username={user.username}>
            <span>{user.firstName}</span>
            <span>{user.lastName}</span>
          </div>
        </Responsive>
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/fullname/component.tsx